// extracted by mini-css-extract-plugin
module.exports = {"actions":"HeroActions_actions__DLOq_","button":"HeroActions_button__FhSbS"};